export const Top = 'top';
export const Left = 'left';
export const Right = 'right';
export const Bottom = 'bottom';

export const TopLeft = 'top-left';
export const TopRight = 'top-right';
export const BottomLeft = 'bottom-left';
export const BottomRight = 'bottom-right';

export const Start = 'start';
export const Middle = 'middle';
export const End = 'end';

export const X = 'x';
export const Y = 'y';

export const Group = 'group';

export const AxisRole = 'axis';
export const TitleRole = 'title';
export const FrameRole = 'frame';
export const ScopeRole = 'scope';
export const LegendRole = 'legend';

export const RowHeader = 'row-header';
export const RowFooter = 'row-footer';
export const RowTitle  = 'row-title';
export const ColHeader = 'column-header';
export const ColFooter = 'column-footer';
export const ColTitle  = 'column-title';

export const Padding = 'padding';

export const Symbols = 'symbol';

export const Fit  = 'fit';
export const FitX = 'fit-x';
export const FitY = 'fit-y';
export const Pad  = 'pad';
export const None = 'none';

export const All = 'all';
export const Each = 'each';
export const Flush = 'flush';

export const Column = 'column';
export const Row = 'row';
